import { render } from "./AttrFileViewer.vue?vue&type=template&id=8b0c6054&scoped=true"
import script from "./AttrFileViewer.vue?vue&type=script&lang=js"
export * from "./AttrFileViewer.vue?vue&type=script&lang=js"

import "./AttrFileViewer.vue?vue&type=style&index=0&id=8b0c6054&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0c6054"],['__file',"src/components/widgets/components_core/AttrFileViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b0c6054"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b0c6054', __exports__)) {
    api.reload('8b0c6054', __exports__)
  }
  
  module.hot.accept("./AttrFileViewer.vue?vue&type=template&id=8b0c6054&scoped=true", () => {
    api.rerender('8b0c6054', render)
  })

}


export default __exports__